import { Button, Dialog, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

const NoAccessPopup = ({
  open,
  message,
}) => {

    const navigate = useNavigate();
  return (
    <Dialog open={open} keepMounted maxWidth="md">
      <Grid
        item
        sx={{
          mb: 2,
          mt: 2,
          pr: 8,
          pl: 8,
          display: 'flex',
          justifyContent: 'center'
        }}
        xs={12}
      >
        <Typography
          style={{
            marginLeft: '0px',
            marginTop: '7px',
            fontWeight: '700',
            fontSize: '20px',
            fontFamily:
              'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
          }}
        >
          {message}
        </Typography>
      </Grid>
      <Grid
        item
        sx={{
          mb: 2,
          mt: 2,
          pr: 2,
          pl: 2,
          display: 'flex',
          justifyContent: 'center'
        }}
        xs={12}
      >
        <Button
          id="btn-onConfirm"
          sx={{
            ml: 2,
            width: '10%',
            background: '#2348FC',
            fontWeight: 'normal'
          }}
          variant="contained"
          type="button"
          onClick={() => {
            navigate('/dashboard');
          }}
        >
          OK
        </Button>
      </Grid>
    </Dialog>
  );
};

export default NoAccessPopup;
